import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycHowDoesAMedicaidAssetProtectionTrustWorkPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-how-does-a-medicaid-asset-protection-trust-work/']} />;
}
